import { useMemo } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { useTranslation } from '@aimsos/i18n';

import { DEFAULT_INTELLIGENCE_SUBTAB, INTELLIGENCE_SUBTABS } from '../../constants/intelligence.js';
import RoutedSubtabSwitch from '../RoutedSubtabSwitch.jsx';

/**
 * The shell shared by the Intelligence subtabs: it owns the Traits / Insights
 * switch and hands it down, so each subtab places it in its own toolbar row —
 * the prototype draws it on the same line as the search box. The profile's own
 * context (entity, tabs, …) is passed through.
 */
function IntelligenceLayout() {
  const { t } = useTranslation('unified-profiles');
  const profileContext = useOutletContext();

  const subtabSwitch = useMemo(
    () => (
      <RoutedSubtabSwitch
        subtabs={INTELLIGENCE_SUBTABS}
        defaultSubtab={DEFAULT_INTELLIGENCE_SUBTAB}
        labelPrefix="intelligence.subtabs"
        ariaLabel={t('intelligence.subtabs.ariaLabel')}
      />
    ),
    [t],
  );

  const context = useMemo(() => ({ ...profileContext, subtabSwitch }), [profileContext, subtabSwitch]);

  return <Outlet context={context} />;
}

export default IntelligenceLayout;
